import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_204: DocMigration = {
  maxSchemaVersion: "0.0.204",
  description: "Rename params to optionSets in locked and hidden entity handles",
  apply(json: any) {
    if (json.locked) {
      for (const entityHash in json.locked) {
        const docHandle = json.locked[entityHash];
        if (docHandle.type === "PARAM") {
          docHandle.type = "OPTION_SET";
        }
        if (docHandle.paramId) {
          docHandle.optionSetId = docHandle.paramId;
          delete docHandle.paramId;
        }
      }
    }
    if (json.hidden) {
      for (const entityHash in json.hidden) {
        const docHandle = json.hidden[entityHash];
        if (docHandle.type === "PARAM") {
          docHandle.type = "OPTION_SET";
        }
        if (docHandle.paramId) {
          docHandle.optionSetId = docHandle.paramId;
          delete docHandle.paramId;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_204;
